import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { ApiError, api } from "@/api/client"
import { MeResponse } from "../../../../backend/src/routes/user/me.types"
import { AxiosError } from "axios"
import useAuth from "@/hooks/useAuth"
import queryKeys from "../queryKeys"

export const loggedUserRequest = async (token?: string) => {
    const { data } = await api({ token }).get<MeResponse>(`/user/me`)
    return data
}

export const useLoggedUserQuery = (
    token?: string,
    options?: Pick<UseQueryOptions<MeResponse, AxiosError<ApiError>>, "refetchInterval" | "refetchIntervalInBackground">
) => {
    const auth = useAuth()

    return useQuery<MeResponse, AxiosError<ApiError>>({
        queryFn: () => loggedUserRequest(token ?? auth.accessToken),
        queryKey: queryKeys.users.me,
        enabled: token !== undefined || auth.accessToken !== undefined,
        ...options,
    })
}
